import twitterLogin from "@/assets/images/twitterLogin.png";
import { getTwitterLogin } from "@/api/h5.js"
import { useDispatch } from "react-redux";

const TwitterLoginButton = () => {
  const dispatch = useDispatch()
  const authHandler = async () => {
    const { data, code } = await getTwitterLogin()
    if (code == '0') {
      window.location.href = data
    }

  };
  return (
    <div onClick={authHandler} className="new_button_shadow flex cursor-pointer relative justify-center items-center gap-[10px] text-[16px] leading-[19px] text-[#fff] w-[192px] h-[32px] font-semibold btn login">
      <img src={twitterLogin} className='w-5 h-5 left-3' alt="" />
      Twitter
    </div>
  );
};
export default TwitterLoginButton